import { useMemo } from 'react';

import { generatePath } from 'react-router-dom';

import { Insurance } from 'constants/routes';
import { useRouteMatch } from 'hooks/useRouteMatch';

const { ROUTES, ROUTE_NAMES } = Insurance;

export const usePageBottomPresenter = () => {
  const { params } = useRouteMatch({ routes: ROUTES }) ?? {};
  const { id: worksheetId } = params ?? {};

  const previousPagePath = useMemo(() => {
    return generatePath(ROUTES[ROUTE_NAMES.HOME].path, { id: worksheetId });
  }, [worksheetId]);

  return { previousPagePath };
};
